import type { NormalizeOAS, OASOutput } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type ResponseBody = OASOutput<O, '/api/scenes', 'get'>;

type Scene = {
  id: number;
  name: string;
  lastUpdateTimeUTC: string;
  thumbnailUrl: string | null;
  hasProcessingFinishedSuccessfully: boolean | null;
};

type Result = Scene[];

export const listScenesFactory = (apiClient: ApiClient) => {
  const listScenes = async () => {
    const response = await apiClient['/api/scenes'].get();
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return response.map((scene) => ({
      id: scene.id,
      name: scene.name,
      lastUpdateTimeUTC: scene.lastUpdateTimeUTC,
      thumbnailUrl: scene.thumbnailUrl ?? null,
      hasProcessingFinishedSuccessfully: scene.hasProcessingFinishedSuccessfully ?? null,
    }));
  };

  return listScenes;
};
